/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconToolsKitchen3 = createReactComponent("tools-kitchen-3", "IconToolsKitchen3", [
  ["path", { d: "M7 4v17m-3 -17v3a3 3 0 1 0 6 0v-3", key: "svg-0" }],
  ["path", { d: "M17 8m-3 0a3 4 0 1 0 6 0a3 4 0 1 0 -6 0", key: "svg-1" }],
  ["path", { d: "M17 12v9", key: "svg-2" }]
]);

export { IconToolsKitchen3 as default };
//# sourceMappingURL=IconToolsKitchen3.js.map
